/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Policy_DetailsInputs */

const en_claims_policy_details = /** @type {(inputs: Claims_Policy_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy Details`)
};

const fr_claims_policy_details = /** @type {(inputs: Claims_Policy_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de la police`)
};

/**
* | output |
* | --- |
* | "Policy Details" |
*
* @param {Claims_Policy_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_policy_details = /** @type {((inputs?: Claims_Policy_DetailsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Policy_DetailsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_policy_details(inputs)
	return fr_claims_policy_details(inputs)
});